import React from 'react';
import { useLoadScript } from '@react-google-maps/api';
import { debounce } from 'lodash';
import Icon from '../components/Icon';
import { GOOGLE_MAPS_SCRIPT_ID } from '../constants';
import { GOOGLE_MAPS_API_KEY } from '../config';

const libraries = ["places"];
const AutocompleteInput = ({ field: { value, onChange, name }, blurAction, setFieldValue, placeholder, invalid }) => {
    const [focused, setFocused] = React.useState(false);
    const autocomplete = React.useRef();
    const [predictions, setPredictions] = React.useState([]);
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: GOOGLE_MAPS_API_KEY,
        libraries,
        id: GOOGLE_MAPS_SCRIPT_ID
    })
    React.useEffect(() => {
        if (isLoaded) {
            autocomplete.current = new window.google.maps.places.AutocompleteService();
        }
    }, [isLoaded])
    function getPlacePredictions(value) {
        if (value && autocomplete.current) {
            autocomplete.current.getPlacePredictions({ input: value }, predictions => {
                if (predictions) {
                    setPredictions(predictions.map( ({ description }) => description));
                }
            })
        }
    }
    const debouncedGetPlacePredictions = React.useCallback(debounce(getPlacePredictions, 250), [])
    React.useEffect(() => {
        debouncedGetPlacePredictions(value)
    }, [value, debouncedGetPlacePredictions])
    function handleBlur() {
        if (blurAction) {
            blurAction();
        }
        setFocused(false);
        setPredictions([]);
    }
    return (
        <div className={`autocomplete-container${focused ? ' focused' : ''}${invalid ? ' invalid' : ''}${Boolean(value) ? ' valid' : ''}`}>
            <div className='ac-icon'>
                <Icon iconName='mapMarker' width={22} />
            </div>
            <div className='input-container'>
                <input
                    placeholder={placeholder}
                    name={name}
                    value={value}
                    onChange={onChange}
                    type="text"
                    autoComplete="off"
                    autoCorrect="off"
                    onFocus={() => setFocused(true)}
                    onBlur={handleBlur}
                />
            </div>
            { focused && value && predictions.length > 0 && <div className='ac-list'>
                <ul>
                    {predictions.map( (prediction, index) => {
                        return (
                            <li key={`prediction-${index}`} className='ac-list-item'>
                                <button type="button" className='btn' onMouseDown={() => setFieldValue(name, prediction)}>
                                    <span className='icon-container'><Icon iconName="mapMarker" width={20} /></span>
                                    <span className='content'>{prediction}</span>
                                </button>
                            </li>
                        )
                    })}
                </ul>
            </div>}
        </div>
    )
}

export default AutocompleteInput;